import { IFIStatus } from '@cims-online/shared'
import { useDisabledOptions } from 'hooks/useDisabledOptions'
import { useIFITrackerContext } from '../../../../IFITrackerContext'
import { EJSelectProps } from './types'
import CIMSFormItem from 'components/CIMSFormItem'
import { HelpMessage } from 'utils/constants'
import CIMSSelect from 'components/CIMSSelect'

const EJSelect: React.FC<EJSelectProps> = ({ statusId }) => {
  const { judgements } = useIFITrackerContext()
  const [disabled, { some }] = useDisabledOptions({
    disabled: statusId === IFIStatus.Closed.id,
    reason: { why: 'only status', statusName: IFIStatus.PendingReview.name },
  })
  return (
    <CIMSFormItem
      label="Engineering Judgements"
      name="judgements"
      disabled={disabled}
      help={HelpMessage.IdentifiedFieldIssues.AssociatedRecordNumber(
        'Engineering Judgement'
      )}
      description="Engineering Judgements can only have one Identified Field Issue. Selected Engineering Judgements will be moved to this Identified Field Issue if they are associated with another."
    >
      <CIMSSelect options={judgements} disabled={some} mode="multiple" />
    </CIMSFormItem>
  )
}

export default EJSelect
